import { getWindow } from "@faire/web/common/globals/getWindow";
import { UAParser } from "ua-parser-js";

export const getOsName = () =>
  new UAParser(getWindow()?.navigator.userAgent).getOS()?.name || "";
